export default {
  SET_DB_LOADED (state, bool) {
    state.dbReady = true
  },
  //
  // ----- Global App Permissions
  //
  SET_TRACKING_ALLOWED (state, bool) {
    state.trackingAllowed = bool
  },
  SET_SENSORS_ALLOWED (state, bool) {
    state.sensorsAllowed = bool
    // If switched off, also deactivate "useStep"
    if (bool === false) {
      state.usePedometer = false
    }
  },
  //
  // -----Browser API permissions
  //
  SET_GEOLOCATION_PERMISSION_STATUS (state, status) {
    state.geolocationPermissionStatus = status
  },
  SET_GYROSCOPE_PERMISSION_STATUS (state, status) {
    state.gyroscopePermissionStatus = status
  },
  //
  // ----- Navigator Geolocation Settings
  //
  SET_ALTITUDE (state, payload) {
    state.altitude = payload
  },
  SET_ALTITUDE_ACCURACY (state, payload) {
    state.altitudeAccuracy = payload
  },
  SET_ENABLE_HIGH_ACCURACY (state, bool) {
    state.enableHighAccuracy = bool
  },
  SET_MAXIMUM_AGE (state, payload) {
    state.maximumAge = +payload
  },
  SET_TIMEOUT (state, milliseconds) {
    state.timeout = +milliseconds
  },
  //
  // ----- Geolocation Recording constrains
  //
  SET_USE_MIN_SPEED_THRESHOLD (state, bool) {
    state.useMinSpeedThreshold = bool
  },
  SET_MIN_SPEED_THRESHOLD (state, float) {
    state.minSpeedThreshold = parseFloat(float)
  },
  SET_USE_RECORDING_TIME_INTERVAL (state, bool) {
    state.useRecordingTimeInterval = bool
  },
  SET_RECORDING_TIME_INTERVAL (state, int) {
    state.recordingTimeInterval = parseInt(int)
  },
  //
  // ----- Reverse Geocoding
  //
  SET_ADDRESS_SERVICE (state, payload) {
    state.addressService = payload
  },
  //
  // ----- Device settings
  //
  SET_SCREEN_WAKE_LOCK_AVAILABILITY (state, bool) {
    state.screenWakeLockAvailability = bool
  },
  //
  // ------ Sensores
  //
  SET_USE_PEDOMETER (state, bool) {
    state.usePedometer = bool
  },
  //
  // ----- Notification when not moving
  //
  SET_SHOW_NOTIFICATION_WHEN_NOT_MOVING (state, bool) {
    state.showNotificationWhenNotMoving = bool
  },
  //
  // ----- Zoom (OpenLayers)
  //
  SET_ZOOM_LEVEL_NEAR (state, int) {
    state.zoomLevelNear = parseInt(int)
  },
  SET_ZOOM_LEVEL_FAR (state, int) {
    state.zoomLevelFar = parseInt(int)
  },
  SET_ZOOM_LEVEL_MANUAL (state, int) {
    state.zoomLevelManual = parseInt(int)
  },
  //
  // ----- Max items per page (Sidebar sections)
  //
  SET_MAX_NOTES_PER_PAGE (state, int) {
    state.maxNotesPerPage = int
  },
  SET_MAX_TRACKED_ROUTES_PER_PAGE (state, int) {
    state.maxTrackedRoutesPerPage = int
  },
  SET_MAX_MAP_HOSTS_PER_PAGE (state, int) {
    state.maxMapHostsPerPage = int
  },
  //
  // ----- Console, Debugging, Logging
  //
  SET_CONSOLE (state, bool) {
    state.console = bool
  },
  SET_DEBUGGING (state, bool) {
    state.debugging = bool
  },
  SET_LOG_TXT (state, payload) {
    const val = payload.val

    let str = '<div class="w-full border mb-1">'
    str += ' <div class="flex w-full items-baseline overflow-hidden line-1 p-1 ' + payload.type + '">'
    str += '  <div class="w-2/12 pr-2 flex-shrink-0">' + payload.type + '</div>'
    str += '  <div class="w-3/12 pr-2 flex-shrink-0">' + payload.title + '</div>'
    str += '  <div class="w-7/12 pr-2 flex-shrink-0">' + payload.text + '</div>'
    str += ' </div>'

    if (val !== undefined) {
      str += ' <div class="w-full flex items-baseline overflow-hidden line-2 p-1">'
      str += val
      str += ' </div>'
    }

    str += '</div>'

    state.log += str
  },
  RESET_LOG (state) {
    state.log = ''
  }
}
